import {
  REGIONS_REQUEST,
  REGIONS_SUCCESS,
  REGIONS_ERROR,
} from "@/store/actions/regions.js";
import HTTP from "@/utils/http";
import Vue from "vue";
import { AUTH_LOGOUT } from "@/store/actions/auth";

const state = {
  regions_get_status: "",
  regions_once_loaded: false,
  regions: [],
};

const getters = {
  getRegions: state => state.regions,
  isRegionsLoading: state => state.regions_get_status === 'loading',
  isRegionsFailed: state => state.regions_get_status === 'error',
  regionsOnceLoaded: state => state.regions_once_loaded,
};

const actions = {
  [REGIONS_REQUEST]: ({ commit, dispatch }) => {
    commit(REGIONS_REQUEST);
    HTTP({ url: "regions" })
      .then(resp => {
        commit(REGIONS_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(REGIONS_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
};

const mutations = {
  [REGIONS_REQUEST]: state => {
    state.regions_get_status = "loading";
  },
  [REGIONS_SUCCESS]: (state, data) => {
    state.regions_get_status = "success";
    Vue.set(state, "regions", data);
    state.regions_once_loaded = true;
  },
  [REGIONS_ERROR]: state => {
    state.regions_get_status = "error";
    state.regions_once_loaded = true;
  },

  [AUTH_LOGOUT]: state => {
    state.regions_get_status = "";
    state.regions_once_loaded = false;
    state.regions = [];
    state.regions_add_status = "";
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};